// extracted by mini-css-extract-plugin
export default {"mLayout":"Ms_oDtbfD2QdzXdkrqkE","headerWrapper":"D9ssgTUX_xjIdjOk8tqr","contentWrapper":"mcSXPUH2LHFn5QNVIJpF","footerWrapper":"jIoIuwLBuR4EFFh_4E3z"};